export default __webpack_public_path__ + "static/media/gt.f5322017.svg";